import gql from "graphql-tag";

export const IMPORT_SECTION_OPT_TYPE = gql`
  mutation ImportSectionOptType($filter: importCostumeType!) {
    importSectionOptType(filter: $filter) {
      id
      name
    }
  }
`;
